import { gsap } from 'gsap'

document.addEventListener('DOMContentLoaded', function () {
  const fadeInTl = gsap.timeline()

  fadeInTl
    .from('.heading-style-h1', {
      autoAlpha: 0, // This takes care of both opacity and visibility
      duration: 0.7, // Duration of the fade-in effect for each elemen
      y: '2rem',
      ease: 'power1.out', // Easing function for the fade-in effect
    })
    .from(
      '.panels_heading-span1',
      {
        autoAlpha: 0, // This takes care of both opacity and visibility
        duration: 0.7, // Duration of the fade-in effect for each element
        y: '2rem',
        ease: 'power1.out', // Easing function for the fade-in effect
      },
      0.3
    )
    .from(
      '.panels_heading_span2',
      {
        autoAlpha: 0, // This takes care of both opacity and visibility
        duration: 0.7, // Duration of the fade-in effect for each element
        y: '2rem',
        ease: 'power1.out', // Easing function for the fade-in effect
      },
      0.3
    )
    .from(
      '#panels-intro-text',
      {
        autoAlpha: 0, // This takes care of both opacity and visibility
        duration: 0.7, // Duration of the fade-in effect for each element
        y: '1rem',
        ease: 'power1.out', // Easing function for the fade-in effect
      },
      0.7
    )
    .from(
      '.panels_item',
      {
        autoAlpha: 0, // This takes care of both opacity and visibility
        duration: 0.8, // Duration of the fade-in effect for each element
        y: '2rem',
        stagger: 0.2,
        ease: 'power1.out', // Easing function for the fade-in effect
      },
      0.5
    )
})
